module.exports = __webpack_public_path__ + "static/media/29DUNON12.e5dbd3ec.jpg";